export default {
  PAYMENT: 'PAYMENT',
  PASSENGERS: 'PASSENGERS',
  CONFIRM: 'CONFIRM',
  NEW_ITINERARY: 'NEW_ITINERARY',
  FLIGHTS_OFFERS: 'FLIGHT_OFFERS'
}
